import View from './MostPopular'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const MostPopular = connect(mapStateToProps)(View)

export default MostPopular
